<template>
  <div class="search-container">
    <div class="search-box">
      <SearchIcon class="search-icon" />
      <input type="text" :value="modelValue" :placeholder="placeholder" @input="onInput" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { defineProps, defineEmits } from 'vue';

import { debounce } from 'lodash';

import SearchIcon from '@/components/icons/IconSearch.vue';

withDefaults(
  defineProps<{
    modelValue: string;
    placeholder: string;
  }>(),
  {
    selectedType: '',
    placeholder: '검색어를 입력해주세요.',
  }
);

const emit = defineEmits<{
  'update:modelValue': [text: string];
  search: [text: string];
}>();

const onInput = (event) => {
  emit('update:modelValue', event.target.value);
  debounce(() => emit('search', event.target.value), 500)();
};
</script>

<style scoped lang="scss">
.search-container {
  display: flex;
  align-items: center;
  position: relative;
  @include respond-to(mobile-landscape) {
    width: 100%;
  }
}

.search-box {
  width: 22.5rem;
  position: relative;
  input {
    padding-left: 40px;
  }
  @include respond-to(mobile-landscape) {
    width: 100%;
  }
}

.search-icon {
  position: absolute;
  left: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  background-color: var(--surface-default);
}
</style>
